import Quill from '../quill';

import { fabric } from 'fabric';
import {
  getGradientAngleFromFabricGradientCoords,
  getFabricGradient,
} from '../gradients';
import cloneDeep from 'lodash-es/cloneDeep';
import isEmpty from 'lodash-es/isEmpty';
import set from 'lodash-es/set';
import uniq from 'lodash-es/uniq';
import countBy from 'lodash-es/countBy';
import isEqual from 'lodash-es/isEqual';

const Delta = Quill.import('delta');

const LIST_TYPES = ['none', 'bullet', 'ordered'];
const BULLET_STYLES = [
  { name: '•', bullets: ['•'], id: 0 },
  { name: '◆, ◇', bullets: ['◆', '◇'], id: 1 },
  { name: '▸, ▹', bullets: ['▸', '▹'], id: 2 },
  { name: '➜', bullets: ['➜'], id: 3 },
  { name: '✘', bullets: ['✘'], id: 4 },
  { name: '●, ○, ■, □', bullets: ['●', '○', '■', '□'], id: 5 },
  {
    name: 'Custom',
    bullets: [],
    id: 666,
  },
];
const _reNewline = /\r?\n/;

const LudusText = fabric.util.createClass(fabric.Textbox, {
  customBulletStyle: ['👉'],
  lineStyles: {},
  bulletStyleMap: ['•'],
  _reSpace: /\s|\n/,
  _reSpaceAndTab: /[ \t\r\u00A0]/,
  _reSpacesAndTabs: /[ \t\r\u00A0]/g,
  _wordJoiners: /[ \t\r\u00A0]/,
  _reNewline: /\r?\n/,
  type: 'ludusText',
  emptyCharWidth: 5,
  styleCase: 'normal',
  leftIndent: 0,
  spaceAfterParagraph: 0,
  // _wordJoiners: /[ \t\r\n\u202F\u00A0 ]/,
  _dimensionAffectingProps: fabric.Textbox.prototype._dimensionAffectingProps.concat(
    'spaceAfterParagraph',
  ),

  keysMap: {
    // 9:  'exitEditing', change from original fabric
    27: 'exitEditing',
    33: 'moveCursorUp',
    34: 'moveCursorDown',
    35: 'moveCursorRight',
    36: 'moveCursorLeft',
    37: 'moveCursorLeft',
    38: 'moveCursorUp',
    39: 'moveCursorRight',
    40: 'moveCursorDown',
  },

  _styleProperties: [
    'leftIndent',
    'stroke',
    'strokeWidth',
    'fill',
    'fontFamily',
    'fontSize',
    'fontWeight',
    'fontStyle',
    'underline',
    'overline',
    'linethrough',
    'deltaY',
    'textBackgroundColor',
    'styleCase',
  ],

  initialize(text, options) {
    options.leftIndent = options.leftIndent || 0;
    options.spaceAfterParagraph = options.spaceAfterParagraph || 0;
    this.delta = options.contents && new Delta(options.contents);
    if (!options.contents) {
      this.delta = LudusText.migrateTextToDelta(text, options);
      this.contents = this.delta;
      options.contents = this.contents;
    } else {
      if (Array.isArray(options.contents)) {
        if (options.contents[0].insert) {
          this.contents = new Delta({ ops: options.contents });
        } else {
          this.delta = LudusText.migrateTextToDelta(text, options);
          this.contents = this.delta;
          options.contents = this.contents;
        }
      } else {
        this.contents = new Delta(options.contents);
      }
    }

    options.styles = null; // USEFULL?

    //

    this.buildLinesFromDelta(this.delta);

    this.__skipDimension = true;
    if (
      !options.selectable &&
      options.ludus &&
      !options.ludus.locked &&
      options.ludus.reference !== null &&
      options.ludus.reference !== undefined
    ) {
      options.selectable = true;
    }
    // if (!text) {
    //   text = LudusText.deltaToText(this.delta);
    // }

    text = LudusText.deltaToText(this.contents);
    options.text = text;

    this.callSuper('initialize', text, options);

    this.__skipDimension = false;
    this.initDimensions();
    if (options.bulletStyleId !== undefined) {
      this.setBulletStyle(options.bulletStyleId);
    }
    this.setControlsVisibility({
      mt: false,
      mb: false,
    });
    this.initialized = true;
  },

  initDimensions: function(updateCoords) {
    if (this.__skipDimension) {
      return;
    }
    this.isEditing && this.initDelayedCursor();
    this.clearContextTop();
    this._clearCache();
    // clear dynamicMinWidth as it will be different after we re-wrap line
    this.dynamicMinWidth = 0;
    // wrap lines
    this._styleMap = this._generateStyleMap(this._splitText());
    // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
    if (this.dynamicMinWidth > this.width) {
      this._set('width', this.dynamicMinWidth);
      if (updateCoords) {
        // updateCoords if called after a change of uppercase
        this.setCoords();
      }
    }
    if (this.textAlign.indexOf('justify') !== -1) {
      // once text is measured we need to make space fatter to make justified text.
      this.enlargeSpaces();
    }
    // clear cache and re-calculate height
    this.height = this.calcTextHeight();
    this.saveState({ propertySet: '_dimensionAffectingProps' });
  },

  setFocusBack() {
    this.editor && this.editor.focus();
  },

  buildLinesFromDelta(delta) {
    this.linesFromDelta = {};
    delta.eachLine((line, attributes, i) => {
      let arrayOfSameLevel = [];

      if (this.linesFromDelta) {
        for (const key in this.linesFromDelta) {
          const entry = this.linesFromDelta[key];
          if (
            (entry.list === 'ordered' || entry.list === 'bullet') &&
            entry.indent === attributes.indent
          ) {
            arrayOfSameLevel.push(entry);
          } else if (
            !entry.list ||
            (entry.list !== 'ordered' && entry.list !== 'bullet') ||
            entry.indent < attributes.indent ||
            (attributes.indent && !entry.indent)
          ) {
            // reset because line is not a list anymore
            arrayOfSameLevel = [];
          }
        }
      }
      if (attributes && !attributes.list) {
        this.linesFromDelta[i] = {
          ...attributes,
        };
      } else if (
        attributes.list === 'ordered' ||
        attributes.list === 'bullet'
      ) {
        this.linesFromDelta[i] = {
          ...attributes,
          listNumber: arrayOfSameLevel.length + 1,
        };
      }
    });
  },

  migrateStyle(styles) {
    if (!styles) {
      return null;
    }
    const blockStyles = [];
    Object.entries(styles).forEach((block, mainIndex) => {
      const migratedStyles = [];
      let offset = null;
      const blockEntries = Object.entries(block[1]);

      const blockIndex = parseInt(block[0]);
      blockEntries.forEach((entry, index) => {
        const charIndex = parseInt(entry[0]);
        offset = offset === null ? charIndex : offset;

        if (Object.keys(entry[1]).length > 0) {
          const entries = Object.entries(entry[1]).filter(
            o => o[0] !== 'originalChar',
          );

          const style = entries && Object.fromEntries(entries);
          const nextEntries =
            blockEntries[index + 1] &&
            Object.entries(blockEntries[index + 1][1]).filter(
              o => o[0] !== 'originalChar',
            );

          const nextStyle = nextEntries && Object.fromEntries(nextEntries);
          const nextStyleIndex =
            nextStyle &&
            parseInt(blockEntries[index + 1] && blockEntries[index + 1][0]);

          if (!isEqual(style, nextStyle) || charIndex + 1 !== nextStyleIndex) {
            migratedStyles.push({
              blockIndex: blockIndex,
              offset,
              length: charIndex - offset + 1,
              style,
            });
            offset = null;
          }
        }
      });
      if (migratedStyles.length) {
        blockStyles[mainIndex] = migratedStyles;
      }
    });
    return blockStyles;
  },

  _calcTextareaPosition: function() {
    return {
      left: 0 + 'px',
      top: 0 + 'px',
      fontSize: 12 + 'px',
      charHeight: 12,
    };
  },

  onCanvasMouseUp(e) {},

  onCanvasObjectScaling(o) {},

  addCanvasListeners() {
    if (!this.canvas) {
      return;
    }
    // Be sure to remove all existing listeners before adding new ones
    this.removeCanvasListeners();
  },

  removeCanvasListeners() {
    if (!this.canvas) {
      return;
    }
    this.canvas.off('tripleclick', this.canvasMouseUpHandle);
  },

  _updateTextarea: function() {
    this.cursorOffsetCache = {};
    if (!this.editor) {
      return;
    }
    if (!this.inCompositionMode) {
      var newSelection = this.fromGraphemeToStringSelection(
        this.selectionStart,
        this.selectionEnd,
        this._text,
      );
      this.editor.container.firstChild.focus();
      this.editor.focus();
      this.editor.setSelection(
        newSelection.selectionStart,
        newSelection.selectionEnd - newSelection.selectionStart,
        'silent',
      );
    }
  },

  onKeyUp: function(e) {
    this.lastKeyDown = null;
    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
      this._copyDone = false;
      return;
    }
    if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapUp[e.keyCode]](e);
    } else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    this.canvas && this.canvas.requestRenderAll();
  },

  onKeyDown: function(e) {
    this.lastKeyDown = e.keyCode;

    if (e.keyCode === 66 && (e.metaKey || e.ctrlKey)) {
      this.toggleBold(true);
    }
    if (e.keyCode === 85 && (e.metaKey || e.ctrlKey)) {
      this.toggleUnderline(true);
    }
    if (e.keyCode === 73 && (e.metaKey || e.ctrlKey)) {
      this.toggleItalic(true);
    }
    if (!this.isEditing || this.inCompositionMode) {
      return;
    }

    if (e.keyCode in this.keysMap && !e.altKey) {
      // if altKey we use default quillJS behavior to select words
      this[this.keysMap[e.keyCode]](e);
    } else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapDown[e.keyCode]](e);
    } else if (e.keyCode === 8 && e.metaKey) {
      // DELETE A LINE
      const start = this.findLineBoundaryLeft(this.selectionStart);
      const length = this.editor.getSelection().index - start;

      this.editor.updateContents(
        new Delta().retain(start).delete(length), // 'World' is deleted
        'user',
      );
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    } else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    if (
      (e.keyCode >= 33 && e.keyCode <= 40) ||
      (e.keyCode === 8 && e.metaKey) // when cmd + delete use fabric not Quill
    ) {
      // if i press an arrow key just update selection

      this.clearContextTop();
      this.renderCursorOrSelection();
    } else {
      this.canvas && this.canvas.requestRenderAll();
    }
  },

  onEditorChange: function(action, delta, oldDelta, source) {
    if (!this.isEditing) {
      return;
    }
    this.cursorOffsetCache = {};
    const text = this.editor.getText().slice(0, -1); // quill ends text with \n which confuse fabric while wrapping lines

    if (action === 'selection-change') {
      this.oldSelection = oldDelta;
      const selection = this.editor.getSelection();
      if (selection) {
        const newSelection = this.fromStringToGraphemeSelection(
          selection.index,
          selection.index + selection.length,
          text,
        );
        //
        if (!this.inCompositionMode) {
          this.selectionStart = newSelection.selectionStart;
          this.selectionEnd = newSelection.selectionEnd;
        }
      }
    }
    if (action === 'text-change') {
      this.text = text;

      this._splitText(); // it necessary to do that to get the correct unwrappedline in getStyleDeclaration() when isUnwrapping
      this.contents = this.editor.getContents();

      this.buildLinesFromDelta(this.contents);

      this.initDimensions();
      this.setCoords();
      this.dirty = true;
    }

    if (this.canvas) {
      this.fire('changed');
      this.canvas.fire('text:changed', { target: this });
      this.canvas.requestRenderAll();
    }
  },

  onClick: function() {
    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
    // this.hiddenTextarea && this.hiddenTextarea.focus();
    this.isEditing && this.editor && this.editor.focus();
  },

  searchWordBoundary: function(selectionStart, direction) {
    var text = this._text;
    var index = this._reSpace.test(text[selectionStart])
      ? selectionStart - 1
      : selectionStart;
    var _char = text[index];
    // change from fabric:
    var reNonWord = fabric.reNonWord;
    // back to original fabric
    while (!reNonWord.test(_char) && index > 0 && index < text.length) {
      index += direction;
      _char = text[index];
    }
    if (reNonWord.test(_char)) {
      index += direction === 1 ? 0 : 1;
    }
    return index;
  },

  initHiddenTextarea: function() {
    const alreadyCreated = document.querySelector('#editor-container');
    let div;
    if (!alreadyCreated) {
      div = document.createElement('div');
      document.body.appendChild(div);
      div.setAttribute('id', 'editor-container');
      div.style.height = '300px';
      div.style.width = '450px';
      div.style.position = 'absolute';
      div.style.transform = 'translateY(-9999px)';
      div.style.transform = 'translateX(-9999px)';
      div.style.zIndex = -3000;
      // to show the div uncomment these cmds
      // div.style.top = '20px';
      // div.style.left = '10px';
      // div.style.zIndex = 3000;
      // div.style.backgroundColor = 'blue';
    } else {
      div = alreadyCreated;
    }
    const bindings = {
      tab: {
        key: 9,
        shiftKey: false,
        handler: function(range, context) {
          // disable tab
          return false;
        },
      },

      bold: {
        key: 'B',
        shortKey: true,
        handler: function(range, context) {
          // disable default shortcut
          return false;
        },
      },

      underline: {
        key: 'U',
        shortKey: true,
        handler: function(range, context) {
          // disable default shortcut
          return false;
        },
      },

      indent: {
        // highlight tab or tab at beginning of list, indent or blockquote
        key: 'Tab',
        shiftKey: false,
        format: ['blockquote', 'list'],
        handler(range, context) {
          this.quill.format('indent', '+1', Quill.sources.USER);
          return false;
        },
      },

      outdent: {
        key: 'Tab',
        shiftKey: true,
        format: ['blockquote', 'list', 'indent'],
        handler(range, context) {
          this.quill.format('indent', '-1', Quill.sources.USER);
          return false;
        },
      },

      'embed left': {
        key: 37,
        shiftKey: null,
        altKey: null,
        handle: function(range, context) {
          return false;
        },
      },

      'embed right': {
        key: 39,
        shiftKey: null,
        altKey: null,
        handle: function(range, context) {
          return false;
        },
      },

      'list autofill': {
        key: ' ',
        shiftKey: null,
        collapsed: true,
        format: {
          list: false,
          'code-block': false,
          blockquote: false,
          header: false,
          table: false,
        },
        prefix: /^\s*?(\d+\.+ |-|\*|\[ ?\]|\[x\])$/,
        handler(range, context) {
          // if (this.quill.scroll.query('list') == null) return true;
          const { length } = context.prefix;
          const [line, offset] = this.quill.getLine(range.index);
          if (offset > length) return true;
          let value;
          switch (context.prefix.trim()) {
            case '[]':
            case '[ ]':
              value = 'unchecked';
              break;
            case '[x]':
              value = 'checked';
              break;
            case '-':
            case '*':
              value = 'bullet';
              break;
            default:
              value = 'ordered';
          }

          this.quill.insertText(range.index, ' ', Quill.sources.USER);

          this.quill.history.cutoff();

          const delta = new Delta()
            .retain(range.index - offset)
            .delete(length + 1)
            .retain(line.length() - 2 - offset)
            .retain(1, { list: value });

          this.quill.updateContents(delta, Quill.sources.USER);
          this.quill.history.cutoff();
          this.quill.setSelection(range.index - length, Quill.sources.SILENT);

          return false;
        },
      },
    };

    this.editor = new Quill(div, {
      modules: {
        keyboard: {
          bindings: bindings,
        },
        toolbar: false,
        history: {
          delay: 200,
          userOnly: true,
        },
      },
      theme: 'snow',
    });

    if (this.contents) {
      this.editor.setContents(this.contents);
    } else {
      this.editor.setText(this.text);
    }

    this.editor.focus();

    this.editor.container.addEventListener(
      'keydown',
      this.onKeyDown.bind(this),
    );
    this.editor.container.addEventListener('keyup', this.onKeyUp.bind(this));

    this.editor.on('editor-change', (e, props, oldProps, source) => {
      this.onEditorChange(e, props, oldProps, source);
    });

    if (!this._clickHandlerInitialized && this.canvas) {
      fabric.util.addListener(
        this.canvas.upperCanvasEl,
        'click',
        this.onClick.bind(this),
      );
      this._clickHandlerInitialized = true;
    }
  },

  exitEditing: function() {
    this.selected = false;
    this.isEditing = false;
    this.delta = this.editor.getContents();

    this.editor.disable();
    this.editor.blur();
    this.editor.container.parentNode.removeChild(this.editor.container);

    this.callSuper('exitEditing');
  },

  enterEditing: function(e) {
    if (this.isEditing || !this.editable || this.canvas.isSpaceDown) {
      return;
    }
    this.contentEdited = true;
    if (this.canvas) {
      this.exitEditingOnOthers(this.canvas);
    }
    this.isEditing = true;
    this.initHiddenTextarea(e);
    this._saveEditingProps();
    this._setEditingProps();
    this._textBeforeEdit = this.text;

    this._tick();
    this._fireSelectionChanged('editing:entered');
    this._fireSelectionChanged();
    if (!this.canvas) {
      return this;
    }
    this.canvas.fire('text:editing:entered', { target: this });
    this.initMouseMoveHandler();
    this.canvas.requestRenderAll();
    this._updateTextarea();
    this.initDimensions();
    return this;
  },

  _getLineLeftOffset: function(lineIndex) {
    const lineWidth = this.getLineWidth(lineIndex);
    if (this.textAlign === 'center') {
      return (
        (this.width -
          (lineWidth -
            this._getLineLeftIndent(this._styleMap[lineIndex].line))) /
        2
      );
    }
    if (this.textAlign === 'right') {
      return this.width - lineWidth;
    }
    if (
      this.textAlign === 'justify-center' &&
      this.isEndOfWrapping(lineIndex)
    ) {
      return (this.width - lineWidth) / 2;
    }

    if (this.textAlign === 'justify-right' && this.isEndOfWrapping(lineIndex)) {
      return this.width - lineWidth;
    }

    return this._getLineLeftIndent(this._styleMap[lineIndex].line);
  },

  _getLineLeftIndent: function(lineIndex) {
    if (this.linesFromDelta[lineIndex] && this.linesFromDelta[lineIndex].list) {
      const indent = (this.linesFromDelta[lineIndex].indent || 0) + 1;

      return !!this.linesFromDelta[lineIndex].list * indent * this.fontSize * 2;
    }
    return 0;
  },

  enlargeSpaces: function() {
    var diffSpace,
      currentLineWidth,
      numberOfSpaces,
      accumulatedSpace,
      line,
      charBound,
      spaces;
    for (var i = 0, len = this._textLines.length; i < len; i++) {
      if (
        this.textAlign !== 'justify' &&
        (i === len - 1 || this.isEndOfWrapping(i))
      ) {
        continue;
      }
      accumulatedSpace = 0;
      line = this._textLines[i];
      currentLineWidth =
        this.getLineWidth(i) + this._getLineLeftIndent(this._styleMap[i].line);
      if (
        currentLineWidth < this.width &&
        (spaces = this.textLines[i].match(this._reSpacesAndTabs))
      ) {
        numberOfSpaces = spaces.length;
        diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
        for (var j = 0, jlen = line.length; j <= jlen; j++) {
          charBound = this.__charBounds[i][j];
          if (this._reSpaceAndTab.test(line[j])) {
            charBound.width += diffSpace;
            charBound.kernedWidth += diffSpace;
            charBound.left += accumulatedSpace;
            accumulatedSpace += diffSpace;
          } else {
            charBound.left += accumulatedSpace;
          }
        }
      }
    }
  },

  _wrapLine: function(_line, lineIndex, desiredWidth, _reservedSpace) {
    var lineWidth = 0;
    var splitByGrapheme = this.splitByGrapheme;
    var graphemeLines = [];
    var line = [];
    // spaces in different languges?
    var words = splitByGrapheme
      ? fabric.util.string.graphemeSplit(_line)
      : _line.split(this._wordJoiners);
    var word = '';
    var offset = 0;
    // var infix = splitByGrapheme ? '' : ' ';
    var infix = splitByGrapheme ? '' : ' ';
    var wordWidth = 0;
    var infixWidth = 0;
    var largestWordWidth = 0;
    var lineJustStarted = true;
    var additionalSpace = splitByGrapheme ? 0 : this._getWidthOfCharSpacing();
    var reservedSpace = _reservedSpace || 0;
    reservedSpace = this._getLineLeftIndent(lineIndex) || 0;

    // }

    // fix a difference between split and graphemeSplit
    if (words.length === 0) {
      words.push([]);
    }
    desiredWidth -= reservedSpace;
    for (var i = 0; i < words.length; i++) {
      // if using splitByGrapheme words are already in graphemes.
      word = splitByGrapheme
        ? words[i]
        : fabric.util.string.graphemeSplit(words[i]);
      wordWidth = this._measureWord(word, lineIndex, offset);
      offset += word.length;

      lineWidth += infixWidth + wordWidth - additionalSpace;

      if (lineWidth >= desiredWidth && !lineJustStarted) {
        graphemeLines.push(line);
        line = [];
        lineWidth = wordWidth;
        lineJustStarted = true;
      } else {
        lineWidth += additionalSpace;
      }

      if (!lineJustStarted && !splitByGrapheme) {
        line.push(infix);
      }
      line = line.concat(word);

      infixWidth = this._measureWord([infix], lineIndex, offset);
      offset++;
      lineJustStarted = false;
      // keep track of largest word
      if (wordWidth > largestWordWidth) {
        largestWordWidth = wordWidth;
      }
    }

    i && graphemeLines.push(line);

    if (
      largestWordWidth + reservedSpace > this.dynamicMinWidth &&
      this._styleMap // only check minwidth when we have a styleMap available
    ) {
      this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
    }
    return graphemeLines;
  },

  isEmptyStyles: function(lineIndex) {
    var map = this._styleMap[lineIndex];
    if (!map) {
      return true;
    }

    const start = this._styleMap[lineIndex].total;
    const len = this._textLines[lineIndex].length;
    if (this.isEditing && this.editor) {
      return !this.editor.getContents(start, len).ops.some(o => o?.attributes);
    }

    if (this.delta) {
      return !this.delta.slice(start, start + len).ops.some(o => o?.attributes);
    }

    return false;
  },

  getHeightOfLine: function(lineIndex, computeSpace = true) {
    const additionalSpace = computeSpace
      ? this._getLineTopOffset(lineIndex)
      : 0;

    if (this.__lineHeights[lineIndex]) {
      return this.__lineHeights[lineIndex] + additionalSpace;
    }

    var line = this._textLines[lineIndex];
    // char 0 is measured before the line cycle because it nneds to char
    // emptylines
    var maxHeight = this.getHeightOfChar(lineIndex, 0);
    for (var i = 1, len = line.length; i < len; i++) {
      maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
    }

    return (
      (this.__lineHeights[lineIndex] =
        maxHeight * this.lineHeight * this._fontSizeMult) +
      (additionalSpace / this.fontSize) * maxHeight
    );
  },

  _getLineTopOffset(lineIndex) {
    if (lineIndex - 1 >= 0 && this.isEndOfWrapping(lineIndex - 1)) {
      return this.spaceAfterParagraph * this._fontSizeMult * this.fontSize;
    }
    return 0;
  },

  applyStyleCase(char, style) {
    if (typeof char === 'undefined') {
      return;
    }
    let styleCase = null;
    if (style && style.styleCase) {
      styleCase = style.styleCase;
    } else if (this.styleCase && this.styleCase !== 'normal') {
      styleCase = this.styleCase;
    }
    if (styleCase) {
      switch (styleCase) {
        case 'uppercase':
          return char.toString().toUpperCase();
        case 'lowercase':
          return char.toString().toLowerCase();
        default:
          break;
      }
    }
    return char;
  },

  isLineIndent(line) {
    const lineIndex = line.toString();
    return (
      this.linesFromDelta[lineIndex] && this.linesFromDelta[lineIndex].list
    );
  },

  getNumbering(lineIndex) {
    const line = this._styleMap[lineIndex].line;
    return this.linesFromDelta[line] && this.linesFromDelta[line].listNumber;
  },

  getIndentStyle(lineIndex) {
    // Revamp with Quill info?
    var line = this._styleMap ? this._styleMap[lineIndex].line : lineIndex;
    return (
      this.linesFromDelta[line] &&
      this.linesFromDelta[line].list &&
      this.linesFromDelta[line]
    );
  },

  setIndentLevel(value) {
    // value mmust be +1 or -1
    if (this.isEditing && this.editor) {
      this.editor.format('indent', value, Quill.sources.USER);
    } else {
      this.delta.ops.forEach(op => {
        if (op && op.attributes) {
          const currentIndent = op.attributes.indent || 0;
          if (value === '+1') {
            set(op, 'attributes.indent', Math.min(currentIndent + 1, 9));
          } else if (value === '-1') {
            set(op, 'attributes.indent', Math.max(currentIndent - 1, 0));
          }
        }
      });

      this.contents = cloneDeep(this.delta);
      this._forceClearCache = true;
      this.buildLinesFromDelta(this.delta);
      this.initDimensions();
      this.fire('modified');
      this.canvas.fire('object:modified', { target: this });
      this.canvas.requestRenderAll();
    }
  },

  getListTypes() {
    return LIST_TYPES;
  },

  getBulletStyles() {
    return BULLET_STYLES;
  },

  getCurrentBulletStyle() {
    const bulletStyleId = this.bulletStyleId || 0;
    const bullet = BULLET_STYLES.find(b => b.id === bulletStyleId);
    return bullet;
  },

  setBulletStyle(id, silent) {
    this.bulletStyleId = id;
    const bullet = BULLET_STYLES.find(b => b.id === id);
    if (bullet) {
      if (bullet.id === 666 && this.customBulletStyle) {
        // custom bullet
        this.bulletStyleMap = this.customBulletStyle;
      } else {
        this.bulletStyleMap = bullet.bullets ? bullet.bullets : [];
      }
    }
    // }
    if (this.canvas && !silent) {
      this.canvas.requestRenderAll();
      this.fire('modified');
      this.canvas.fire('object:modified', { target: this });
    }
  },

  getListStyle() {
    if (this.isEditing) {
      // if getFormat return empty object, check domNodes if one of LI => return multiple
      const selection = this.editor.getSelection();
      const actualFormat = this.editor.getFormat(
        selection || { index: 0, length: 0 },
      );
      if (isEmpty(actualFormat)) {
        const selection = this.editor.getSelection();
        if (selection) {
          const hasList = !!this.editor
            .getLines(this.editor.getSelection())
            .find(o => {
              return o.domNode && o.domNode.nodeName === 'LI';
            });
          if (hasList) {
            return 'Multiple';
          }
        }
      }
      return actualFormat.list;
    } else {
      if (this.linesFromDelta) {
        const types = Object.entries(countBy(this.linesFromDelta, 'list'));
        if (types.length === 1) {
          const type = types[0][0];
          if (type !== 'null' && type !== 'undefined') {
            return type;
          } else {
            return 'none';
          }
        }
        return 'Multiple';
      }
    }
    return 'none';
  },

  setListStyle(_style, silently) {
    const style = _style.toLowerCase();
    if (this.isEditing) {
      if (style === 'none') {
        this.editor.format('list', false);
        this.editor.format('indent', false);
      } else {
        this.editor.format('list', style);
      }
      this.initDimensions();
    } else {
      const currentDelta = cloneDeep(this.delta);
      currentDelta.ops.forEach(op => {
        if (style === 'none' && op?.attributes) {
          op.attributes.list = null;
          op.attributes.indent = null;
        } else if (op) {
          set(op, 'attributes.list', style);
        }
      });

      this.delta = new Delta(currentDelta);
      this.contents = cloneDeep(this.delta);
      this._forceClearCache = true;
      this.buildLinesFromDelta(this.delta);
      this.initDimensions();
      if (!silently) {
        this.fire('modified');
        this.canvas.fire('object:modified', { target: this });
        this.canvas.requestRenderAll();
      }
    }
  },

  getBulletText(lineIndex) {
    var n = this.getIndentStyle(lineIndex);
    if (
      lineIndex !== 0 &&
      this._styleMap[lineIndex].line === this._styleMap[lineIndex - 1].line
    )
      return '';

    if (!n || !n.list) {
      return '';
    }
    switch (n.list) {
      case 'ordered':
        return this.getNumbering(lineIndex) + '.';
      case 'bullet': {
        const level = n.indent ? n.indent : 0;
        const len = level % this.bulletStyleMap.length;
        return this.bulletStyleMap[len];
      }
      default:
        return '';
    }
  },

  getMeasuringContext: function() {
    // if we did not return we have to measure something.
    if (typeof OffscreenCanvas !== 'undefined') {
      if (!fabric._measuringContext) {
        fabric._measuringContext = new OffscreenCanvas(0, 0).getContext('2d');
      }
    } else {
      if (!fabric._measuringContext) {
        fabric._measuringContext =
          (this.canvas && this.canvas.contextCache) ||
          fabric.util.createCanvasElement().getContext('2d');
      }
    }
    return fabric._measuringContext;
  },

  _renderTextLine(method, ctx, line, left, top, lineIndex, heightOfLine) {
    this._renderChars(method, ctx, line, left, top, lineIndex, heightOfLine);
    var bullet = this.getBulletText(lineIndex);
    if (bullet) {
      top -= this.fontSize * this._fontSizeFraction;
      this._renderChar(
        method,
        ctx,
        lineIndex,
        0,
        bullet,
        left - this._measureWord(bullet, lineIndex) - this.fontSize,
        top,
      );
    }
  },

  _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
    // first i try to return from cache
    if (this._styleMap) {
      // only try to apply case if we did initialise the styleMap (per character)
      _char = this.applyStyleCase(_char, charStyle);
      previousChar = this.applyStyleCase(previousChar, prevCharStyle);
    }
    var fontCache = this.getFontCache(charStyle);
    var fontDeclaration = this._getFontDeclaration(charStyle);
    var previousFontDeclaration = this._getFontDeclaration(prevCharStyle);
    var couple = previousChar + _char;
    var stylesAreEqual = fontDeclaration === previousFontDeclaration;
    var width;
    var coupleWidth;
    var previousWidth;
    var fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;
    var kernedWidth;

    if (previousChar && fontCache[previousChar] !== undefined) {
      previousWidth = fontCache[previousChar];
    }
    if (fontCache[_char] !== undefined) {
      kernedWidth = width = fontCache[_char];
    }
    if (stylesAreEqual && fontCache[couple] !== undefined) {
      coupleWidth = fontCache[couple];
      kernedWidth = coupleWidth - previousWidth;
    }
    if (
      width === undefined ||
      previousWidth === undefined ||
      coupleWidth === undefined
    ) {
      var ctx = this.getMeasuringContext();
      // send a TRUE to specify measuring font size CACHE_FONT_SIZE
      this._setTextStyles(ctx, charStyle, true);
    }
    if (width === undefined) {
      kernedWidth = width = ctx.measureText(_char).width;
      fontCache[_char] = width;
    }
    if (previousWidth === undefined && stylesAreEqual && previousChar) {
      previousWidth = ctx.measureText(previousChar).width;
      fontCache[previousChar] = previousWidth;
    }
    if (stylesAreEqual && coupleWidth === undefined) {
      // we can measure the kerning couple and subtract the width of the previous character
      coupleWidth = ctx.measureText(couple).width;
      fontCache[couple] = coupleWidth;
      kernedWidth = coupleWidth - previousWidth;
    }
    return {
      width: width * fontMultiplier,
      kernedWidth: kernedWidth * fontMultiplier,
    };
  },

  _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
    // _stylemap is object of rendered lines, with the offset for each$
    var decl = this._getStyleDeclaration(lineIndex, charIndex, _char);
    var fullDecl = this.getCompleteStyleDeclaration(
      lineIndex,
      charIndex,
      _char,
    );
    var shouldFill = method === 'fillText' && fullDecl.fill;
    var shouldStroke =
      method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;
    if (!shouldStroke && !shouldFill) {
      return;
    }
    decl && ctx.save();
    if (this.fill.coords && fullDecl.fill?.indexOf?.(',rgb') > -1)
      fullDecl.fill = this.fill;
    this._applyCharStyles(method, ctx, lineIndex, charIndex, fullDecl);

    if (decl && decl.textBackgroundColor) {
      this._removeShadow(ctx);
    }
    if (decl && decl.deltaY) {
      top += decl.deltaY;
    }
    _char = this.applyStyleCase(_char, decl);
    shouldFill && ctx.fillText(_char, left, top);
    shouldStroke && ctx.strokeText(_char, left, top);
    decl && ctx.restore();
  },
  _renderChars: function(method, ctx, line, left, top, lineIndex, lineHeight) {
    var realLineHeight = this.getHeightOfLine(lineIndex, false);
    var isJustify = this.textAlign.indexOf('justify') !== -1;
    var actualStyle;
    var nextStyle;
    var charsToRender = '';
    var charBox;
    var boxWidth = 0;
    var timeToRender;
    var shortCut =
      !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex);

    ctx.save();
    top -= (realLineHeight * this._fontSizeFraction) / this.lineHeight;

    if (shortCut) {
      this._renderChar(
        method,
        ctx,
        lineIndex,
        0,
        this.textLines[lineIndex],
        left,
        top,
      );
      ctx.restore();
      return;
    }
    for (var i = 0, len = line.length - 1; i <= len; i++) {
      timeToRender = i === len || this.charSpacing;
      charsToRender += line[i];
      charBox = this.__charBounds[lineIndex][i];
      if (boxWidth === 0) {
        left += charBox.kernedWidth - charBox.width;
        boxWidth += charBox.width;
      } else {
        boxWidth += charBox.kernedWidth;
      }
      if (isJustify && !timeToRender) {
        if (this._reSpaceAndTab.test(line[i])) {
          timeToRender = true;
        }
      }
      if (!timeToRender) {
        // if we have charSpacing, we render char by char
        actualStyle =
          actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
        nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
        timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
      }
      if (timeToRender) {
        this._renderChar(
          method,
          ctx,
          lineIndex,
          i,
          charsToRender,
          left,
          top,
          actualStyle,
        );
        charsToRender = '';
        actualStyle = nextStyle;
        left += boxWidth;
        boxWidth = 0;
      }
    }
    ctx.restore();
  },

  getCompleteStyleDeclaration: function(lineIndex, charIndex, _char) {
    var style = this._getStyleDeclaration(lineIndex, charIndex, _char) || {};
    return this.completeStyle(style);
  },

  completeStyle: function(style) {
    var styleObject = {};
    var prop;
    for (var i = 0; i < this._styleProperties.length; i++) {
      prop = this._styleProperties[i];
      if (
        style[prop] !== 'undefined' &&
        prop === 'fill' &&
        Array.isArray(style[prop])
      ) {
        styleObject[prop] = uniq(style[prop]);
      } else {
        styleObject[prop] =
          typeof style[prop] === 'undefined' ? this[prop] : style[prop];
      }
    }
    return styleObject;
  },

  _splitTextIntoLines: function(text) {
    var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text);
    var graphemeLines = this._wrapText(newText.lines, this.width);
    var lines = new Array(graphemeLines.length);
    for (var i = 0; i < graphemeLines.length; i++) {
      lines[i] = graphemeLines[i].join('');
    }
    newText.lines = lines;
    newText.graphemeLines = graphemeLines;
    return newText;
  },

  _getStyleDeclaration: function(lineIndex, charIndex, _char) {
    // this.textLines = array of wrapped line no spaces included at the end of wrap
    // this._textLines = array of wrapped line chars splitted
    // this._unwrappedTextLines = array of unwrapped lines with spaces included
    if (this._styleMap) {
      var map = this._styleMap[lineIndex];
      if (!map) {
        return null;
      }

      const line = this.isWrapping ? this._styleMap[lineIndex].line : lineIndex;

      let _charIndex = 0;
      if (this.isWrapping) {
        _charIndex =
          this._unwrappedTextLines
            .slice(0, lineIndex)
            .reduce((acc, line) => acc + Math.max(line.length + 1, 1), 0) +
          charIndex;
      } else {
        _charIndex = this._styleMap[line].total + charIndex;
      }
      let attributes = null;
      const useStyleMap = this._styleMap && this._styleMap.styles.length;
      if (this.isEditing) {
        attributes = useStyleMap
          ? this._styleMap.styles[_charIndex]
          : this.editor.getFormat(_charIndex, 1);

        if (
          isEmpty(attributes) &&
          charIndex === 0 &&
          this._styleMap[lineIndex].offset === 0
        ) {
          // new line don't to pass a length to getFormat so we get the "previous char style"
          attributes = this.editor.getFormat(_charIndex, 0);
        }
      } else if (this.delta) {
        if (useStyleMap) {
          attributes = this._styleMap.styles[_charIndex];
        } else {
          const op = this.delta.slice(_charIndex, _charIndex + 1).ops[0];
          attributes = op && op.attributes;
        }
      }

      if (attributes) {
        return attributes;
      }
    }
    return null;
  },

  styleHas: function(property, lineIndex) {
    if (typeof lineIndex === 'undefined') {
      if (this.editor && this.isEditing) {
        return !!this.editor
          .getContents(0, this.text.length)
          .ops.some(o => o?.attributes && o.attributes[property]);
      }
      if (this.delta) {
        return this.delta.ops.some(
          o => o?.attributes && o.attributes[property],
        );
      }
    } else {
      var map = this._styleMap[lineIndex];
      if (!map) {
        return null;
      }

      const start = this._styleMap[lineIndex].total;

      const len = this._textLines[lineIndex].length + 1;
      return this.editor
        ? this.editor
            .getContents(start, len)
            .ops.some(o => o?.attributes && o.attributes[property])
        : this.delta
            .slice(start, start + len)
            .ops.some(o => o?.attributes && o.attributes[property]);
    }

    return false;
  },

  combineFormats: function(formats, combined) {
    return Object.keys(combined).reduce((merged, name) => {
      if (formats[name] == null) return merged;
      if (combined[name] === formats[name]) {
        merged[name] = combined[name];
      } else if (Array.isArray(combined[name])) {
        if (combined[name].indexOf(formats[name]) < 0) {
          merged[name] = combined[name].concat([formats[name]]);
        }
      } else {
        merged[name] = [combined[name], formats[name]];
      }
      return merged;
    }, {});
  },

  getSelectionStyles: function(skipLineBreak, styleProperties) {
    let selection = this.isEditing && this.editor.getSelection();

    if (!selection && this.oldSelection) {
      selection = this.oldSelection;
    }

    if (this.isEditing && !selection) {
      // Quill editor is probably not fully ready
      return this.completeStyle({});
      // return {};
    }
    const start = selection.index;
    const end = selection.length;

    if (this.isEditing && selection.length === 0) {
      // return usual quill styling when no seletion is made
      return this.completeStyle(
        this.editor.getFormat(selection || { range: 0, length: 0 }),
      );
    }

    const delta = this.isEditing
      ? this.editor.getContents(start, end)
      : this.delta;
    const style = {};

    const _styleProperties = styleProperties || this._styleProperties;

    if (delta) {
      for (let index = 0; index < delta.ops.length; index++) {
        const op = delta.ops[index];
        const breaklines =
          skipLineBreak && op && op.insert && op.insert.match(/\n/g);
        _styleProperties.forEach(prop => {
          if (!(breaklines && breaklines.length === op?.insert?.length)) {
            if (
              op &&
              op.attributes &&
              op.attributes[prop] !== undefined &&
              op.insert !== '\n'
            ) {
              const value = op.attributes[prop];
              if (style[prop] !== undefined && style[prop] !== value) {
                if (prop === 'fill') {
                  style[prop] = Array.isArray(style[prop])
                    ? [...style[prop], value.split(',rgba(')[0]]
                    : [style[prop], value];
                } else {
                  style[prop] = 'Multiple';
                }
              } else {
                style[prop] = value;
              }
            } else if (op && op.insert && op.insert !== '\n') {
              if (style[prop] !== undefined && style[prop] !== this[prop]) {
                if (prop === 'fill') {
                  style[prop] = Array.isArray(style[prop])
                    ? [...style[prop], this[prop]]
                    : [style[prop], this[prop]];
                } else {
                  style[prop] = 'Multiple';
                }
              } else if (!style[prop]) {
                style[prop] = this[prop];
              }
            }
          }
        });
      }
    }
    // );
    return this.completeStyle(style);
  },

  setSelectionStyles: function(styles) {
    if (this.isEditing && this.editor) {
      if (styles.fill && this.fill.coords) {
        this.removeCharStyles('fill');
        this.fill = styles.fill;
      }
      const styleAsArray = Object.entries(styles);
      if (!this.editor.hasFocus()) {
        styleAsArray.forEach(style => {
          this.editor.formatText(
            this.selectionStart,
            this.selectionEnd - this.selectionStart,
            style[0],
            style[1],
            'user',
          );
        });
      } else {
        styleAsArray.forEach(style => {
          this.editor.format(style[0], style[1], 'user');
        });
      }

      this._forceClearCache = true;
    } else {
      const prop = Object.entries(styles)[0];
      this.removeCharStyles(prop[0]);
      this.set(styles);
      if (styles.styleCase && styles.styleCase === 'uppercase') {
        // make sure to reinit dimensions and re calculte coords
        this.initDimensions(true);
      }
      this._forceClearCache = true;
      this.fire('modified');
      // this.canvas.fire('object:modified', { target: this });
      // this.canvas.requestRenderAll();
    }
    return this;
  },

  toggleSelectionStyle: function({
    prop,
    value,
    defaultValue,
    dispatchModified,
  }) {
    const currentStyles = this.getSelectionStyles(true);
    if (currentStyles[prop] !== undefined && currentStyles[prop] !== value) {
      this.setSelectionStyles({
        [prop]: value,
      });
    } else {
      this.setSelectionStyles({
        [prop]:
          this[prop] !== defaultValue && this[prop] !== value
            ? this[prop]
            : defaultValue,
      });
    }
    if (dispatchModified) {
      this.canvas.requestRenderAll();
      this.canvas.fire('object:modified', { target: this });
    }
  },

  toggleBold: function(dispatchModified) {
    this.toggleSelectionStyle({
      prop: 'fontWeight',
      value: '700',
      defaultValue: '400',
      dispatchModified,
    });
  },

  toggleItalic: function(dispatchModified) {
    this.toggleSelectionStyle({
      prop: 'fontStyle',
      value: 'italic',
      defaultValue: 'normal',
      dispatchModified,
    });
  },

  toggleUnderline: function(dispatchModified) {
    this.toggleSelectionStyle({
      prop: 'underline',
      value: true,
      defaultValue: false,
      dispatchModified,
    });
  },

  toggleLinethrough: function(dispatchModified) {
    this.toggleSelectionStyle({
      prop: 'linethrough',
      value: true,
      defaultValue: false,
      dispatchModified,
    });
  },

  renderCursor(boundaries, ctx) {
    const cursorLocation = this.get2DCursorLocation();
    const lineIndex = cursorLocation.lineIndex;
    const charIndex =
      cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0;
    const charHeight = this.getValueOfPropertyAt(
      lineIndex,
      charIndex,
      'fontSize',
    );
    const multiplier = this.scaleX * this.canvas.getZoom();
    const cursorWidth = this.cursorWidth / multiplier;
    let topOffset = boundaries.topOffset;
    const dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');

    topOffset +=
      ((1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex, false)) /
        this.lineHeight -
      charHeight * (1 - this._fontSizeFraction);

    if (this.inCompositionMode) {
      this.renderSelection(boundaries, ctx);
    }

    ctx.fillStyle = this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
    ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
    ctx.fillRect(
      boundaries.left + boundaries.leftOffset - cursorWidth / 2,
      boundaries.top + topOffset + dy + this._getLineTopOffset(lineIndex),
      cursorWidth,
      charHeight,
    );
  },

  findLineBoundaryLeft(startFrom) {
    return startFrom - this.get2DCursorLocation(startFrom).charIndex;
  },

  findLineBoundaryRight(startFrom) {
    const line = this.get2DCursorLocation(startFrom);
    const lineLen = this._textLines[line.lineIndex].length;
    const charIndex = line.charIndex;
    return startFrom + lineLen - charIndex;
  },

  _generateStyleMap(textInfo) {
    var realLineCount = 0;
    var realLineCharCount = 0;
    var charCount = 0;
    var map = {};

    for (var i = 0; i < textInfo.graphemeLines.length; i++) {
      if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
        realLineCharCount = 0;
        charCount++;
        realLineCount++;
      } else if (
        !this.splitByGrapheme &&
        this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) &&
        i > 0
      ) {
        // this case deals with space's that are removed from end of lines when wrapping
        realLineCharCount++;
        charCount++;
      }

      map[i] = {
        line: realLineCount,
        offset: realLineCharCount,
        total: charCount,
      };

      charCount += textInfo.graphemeLines[i].length;
      realLineCharCount += textInfo.graphemeLines[i].length;
    }

    map.styles = [];
    if (this.isEditing && this.editor) {
      for (let index = 0; index < textInfo.graphemeText.length; index++) {
        map.styles.push(this.editor.getFormat(index, 1));
      }
    } else if (this.delta) {
      for (let index = 0; index < textInfo.graphemeText.length; index++) {
        const op = this.delta.slice(index, index + 1).ops[0];
        map.styles.push(op ? op.attributes : {});
      }
    }

    return map;
  },

  renderSelection(boundaries, ctx) {
    const selectionStart = this.selectionStart;
    const selectionEnd = this.selectionEnd;

    const isJustify = this.textAlign.indexOf('justify') !== -1;
    const start = this.get2DCursorLocation(selectionStart);
    const end = this.get2DCursorLocation(selectionEnd);
    const startLine = start.lineIndex;
    const endLine = end.lineIndex;
    const startChar = start.charIndex < 0 ? 0 : start.charIndex;
    const endChar = end.charIndex < 0 ? 0 : end.charIndex;
    for (let i = startLine; i <= endLine; i++) {
      const lineOffset = this._getLineLeftOffset(i) || 0;
      let lineHeight = this.getHeightOfLine(i);
      const lineRealHeight = this.getHeightOfLine(i, false);
      const lineTopOffset = lineHeight - lineRealHeight;
      let realLineHeight = 0;
      let boxStart = 0;
      let boxEnd = 0;

      if (i === startLine) {
        boxStart = this.__charBounds[startLine][startChar].left;
      }
      if (i >= startLine && i < endLine) {
        boxEnd =
          isJustify && !this.isEndOfWrapping(i)
            ? this.width
            : this.getLineWidth(i) || this.emptyCharWidth;
      } else if (i === endLine) {
        if (endChar === 0) {
          boxEnd = this.__charBounds[endLine][endChar].left;
        } else {
          const charSpacing = this._getWidthOfCharSpacing();
          boxEnd =
            this.__charBounds[endLine][endChar - 1].left +
            this.__charBounds[endLine][endChar - 1].width -
            charSpacing;
        }
      }
      realLineHeight = lineHeight;
      if (this.lineHeight < 1 || (i === endLine && this.lineHeight > 1)) {
        lineHeight /= this.lineHeight;
      }
      if (this.inCompositionMode) {
        ctx.fillStyle = this.compositionColor || 'black';
        ctx.fillRect(
          boundaries.left + lineOffset + boxStart,
          boundaries.top + boundaries.topOffset + lineTopOffset,
          boxEnd - boxStart,
          1,
        );
      } else {
        ctx.fillStyle = this.selectionColor;
        ctx.fillRect(
          boundaries.left + lineOffset + boxStart,
          boundaries.top + boundaries.topOffset + lineTopOffset,
          boxEnd - boxStart,
          lineRealHeight / this.lineHeight,
        );
      }

      boundaries.topOffset += realLineHeight;
    }
  },

  _renderTextCommon: function(ctx, method) {
    ctx.save();
    var lineHeights = 0;
    var left = this._getLeftOffset();
    var top = this._getTopOffset();
    var offsets = this._applyPatternGradientTransform(
      ctx,
      method === 'fillText' ? this.fill : this.stroke,
    );

    for (var i = 0, len = this._textLines.length; i < len; i++) {
      var heightOfLine = this.getHeightOfLine(i, false);
      var maxHeight = heightOfLine / this.lineHeight;

      var leftOffset = this._getLineLeftOffset(i);
      var topOffset = this._getLineTopOffset(i);
      this._renderTextLine(
        method,
        ctx,
        this._textLines[i],
        left + leftOffset - offsets.offsetX,
        top + lineHeights + maxHeight - offsets.offsetY + topOffset,
        i,
        heightOfLine,
      );
      lineHeights += heightOfLine + topOffset;
    }
    ctx.restore();
  },

  _hasStyleChanged: function(prevStyle, thisStyle) {
    return (
      prevStyle.fill !== thisStyle.fill ||
      prevStyle.stroke !== thisStyle.stroke ||
      prevStyle.strokeWidth !== thisStyle.strokeWidth ||
      prevStyle.fontSize !== thisStyle.fontSize ||
      prevStyle.fontFamily !== thisStyle.fontFamily ||
      prevStyle.fontWeight !== thisStyle.fontWeight ||
      prevStyle.fontStyle !== thisStyle.fontStyle ||
      prevStyle.deltaY !== thisStyle.deltaY ||
      prevStyle.styleCase !== thisStyle.styleCase
    );
  },

  _renderTextDecoration: function(ctx, type) {
    if (!this[type] && !this.styleHas(type)) {
      return;
    }
    var heightOfLine;
    var size;
    var _size;
    var lineLeftOffset;
    var dy;
    var _dy;
    var line;
    var lastDecoration;
    var leftOffset = this._getLeftOffset();
    var topOffset = this._getTopOffset();
    var top;
    var boxStart;
    var boxWidth;
    var charBox;
    var currentDecoration;
    var maxHeight;
    var currentFill;
    var lastFill;
    var charSpacing = this._getWidthOfCharSpacing();
    var lineTopOffset = 0;
    for (var i = 0, len = this._textLines.length; i < len; i++) {
      heightOfLine = this.getHeightOfLine(i);
      var realHeightOfLine = this.getHeightOfLine(i, false);
      lineTopOffset = this._getLineTopOffset(i);
      // heightOfLine - realHeightOfLine;
      if (!this[type] && !this.styleHas(type, i)) {
        topOffset += heightOfLine;
        continue;
      }
      line = this._textLines[i];
      maxHeight = realHeightOfLine / this.lineHeight;
      lineLeftOffset = this._getLineLeftOffset(i);
      boxStart = 0;
      boxWidth = 0;
      lastDecoration = this.getValueOfPropertyAt(i, 0, type);
      lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
      top =
        topOffset + maxHeight * (1 - this._fontSizeFraction) + lineTopOffset;
      size = this.getHeightOfChar(i, 0);
      dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
      for (var j = 0, jlen = line.length; j < jlen; j++) {
        charBox = this.__charBounds[i][j];
        currentDecoration = this.getValueOfPropertyAt(i, j, type);
        currentFill = this.getValueOfPropertyAt(i, j, 'fill');
        _size = this.getHeightOfChar(i, j);
        _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
        if (
          (currentDecoration !== lastDecoration ||
            currentFill !== lastFill ||
            _size !== size ||
            _dy !== dy) &&
          boxWidth > 0
        ) {
          ctx.fillStyle = lastFill;
          lastDecoration &&
            lastFill &&
            ctx.fillRect(
              leftOffset + lineLeftOffset + boxStart,
              top + this.offsets[type] * size + dy,
              boxWidth,
              this.fontSize / 15,
            );
          boxStart = charBox.left;
          boxWidth = charBox.width;
          lastDecoration = currentDecoration;
          lastFill = currentFill;
          size = _size;
          dy = _dy;
        } else {
          boxWidth += charBox.kernedWidth;
        }
      }
      ctx.fillStyle = currentFill;
      currentDecoration &&
        currentFill &&
        ctx.fillRect(
          leftOffset + lineLeftOffset + boxStart,
          top + this.offsets[type] * size + dy,
          boxWidth - charSpacing,
          this.fontSize / 15,
        );
      topOffset += heightOfLine;
    }
    // if there is text background color no
    // other shadows should be casted
    this._removeShadow(ctx);
  },

  calcTextHeight: function() {
    var lineHeight;
    var height = 0;
    for (var i = 0, len = this._textLines.length; i < len; i++) {
      lineHeight = this.getHeightOfLine(i, false);
      height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
    }
    height +=
      (this._unwrappedTextLines.length - 1) *
      this.spaceAfterParagraph *
      this.fontSize *
      this._fontSizeMult;
    return height;
  },

  _set(key, value) {
    if (!this.initialized) {
      this.callSuper('_set', key, value);
      return this;
    }
    if (key === 'fill') {
      if (value && value.type) {
        // clean up the inline styles if we apply a gradient
        this.removeCharStyles('fill');
      }
    }
    const newValue = value;
    if (key === 'canvas') {
      if (newValue) {
        // Canvas is set, we can use it
        this.addCanvasListeners();
      } else {
        this.removeCanvasListeners();
      }
    }

    if (key === 'customBulletStyle') {
      this.customBulletStyle = newValue;
      this.bulletStyleMap = newValue;
      this.fire('modified');
      this.canvas.fire('object:modified', { target: this });
      this.canvas.requestRenderAll();
      return this;
    }

    this.callSuper('_set', key, newValue);

    return this;
  },

  setCoords(ignoreZoom, skipAbsolute) {
    const coords = this.callSuper('setCoords', ignoreZoom, skipAbsolute);
    this.updateGradient();
    return coords;
  },

  updateGradient(offsetX = 0, offsetY = 0) {
    if (!this.fill || !this.fill.coords) {
      return;
    }
    const angle = getGradientAngleFromFabricGradientCoords(this.fill.coords);
    const gradient = getFabricGradient(
      {
        ...this.fill,
        angle,
      },
      this.width,
      this.height,
      offsetX,
      offsetY,

      false,
    );
    // this.removeCharStyles('fill');
    this._forceClearCache = true;
    this.fill = gradient;
  },

  _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
    var textSpans = [];
    var textBgRects = [];
    var height = textTopOffset;
    var lineOffset;
    // bounding-box background
    this._setSVGBg(textBgRects);

    // text and text-background
    for (var i = 0, len = this._textLines.length; i < len; i++) {
      lineOffset = this._getLineLeftOffset(i);
      if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
        this._setSVGTextLineBg(
          textBgRects,
          i,
          textLeftOffset + lineOffset,
          height,
        );
      }
      this._setSVGTextLineText(
        textSpans,
        i,
        textLeftOffset + lineOffset,
        height,
      );
      height += this.getHeightOfLine(i);
    }

    return {
      textSpans: textSpans,
      textBgRects: textBgRects,
    };
  },

  _setSVGTextLineText: function(
    textSpans,
    lineIndex,
    textLeftOffset,
    textTopOffset,
  ) {
    // set proper line offset
    var lineHeight = this.getHeightOfLine(lineIndex);
    var lineRealHeight = this.getHeightOfLine(lineIndex, false);

    const lineTopOffset = lineHeight - lineRealHeight;
    var isJustify = this.textAlign.indexOf('justify') !== -1;
    var actualStyle;
    var nextStyle;
    var charsToRender = '';
    var charBox;
    var style;
    var boxWidth = 0;
    var line = this._textLines[lineIndex];
    var timeToRender;

    textTopOffset +=
      (lineRealHeight * (1 - this._fontSizeFraction)) / this.lineHeight;
    for (var i = 0, len = line.length - 1; i <= len; i++) {
      timeToRender = i === len || this.charSpacing;
      charsToRender += line[i];
      charBox = this.__charBounds[lineIndex][i];
      if (boxWidth === 0) {
        textLeftOffset += charBox.kernedWidth - charBox.width;
        boxWidth += charBox.width;
      } else {
        boxWidth += charBox.kernedWidth;
      }
      if (isJustify && !timeToRender) {
        if (this._reSpaceAndTab.test(line[i])) {
          timeToRender = true;
        }
      }

      const isLineIndent = this.isLineIndent(this._styleMap[lineIndex].line);

      if (i === 0 && isLineIndent) {
        if (this.bulletStyleId) {
          this.setBulletStyle(this.bulletStyleId, true);
        }
        var bullet = this.getBulletText(lineIndex) || '';
        style = this._getStyleDeclaration(lineIndex, i) || {};

        textSpans.push(
          this._createTextCharSpan(
            bullet,
            style,
            textLeftOffset -
              this._measureWord(bullet, lineIndex) -
              this.fontSize,
            textTopOffset + lineTopOffset,
          ),
        );
      }
      if (!timeToRender) {
        // if we have charSpacing, we render char by char
        actualStyle =
          actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
        nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
        timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
      }
      if (timeToRender) {
        style = this._getStyleDeclaration(lineIndex, i) || {};
        charsToRender = this.applyStyleCase(charsToRender.toString(), style);
        textSpans.push(
          this._createTextCharSpan(
            charsToRender,
            style,
            textLeftOffset,
            textTopOffset + lineTopOffset,
          ),
        );
        charsToRender = '';
        actualStyle = nextStyle;
        textLeftOffset += boxWidth;
        boxWidth = 0;
      }
    }
  },

  // remove useless style when setting prop at object level (not in editing mode)
  removeCharStyles(styleName) {
    if (this.isEditing && this.delta) {
      this.editor.formatText(0, this.text.length, styleName, false);
    }

    if (this.delta) {
      const newDelta = cloneDeep(this.delta);
      newDelta.slice(0, this.text.length).ops.forEach(o => {
        if (o?.attributes && o.attributes[styleName]) {
          delete o.attributes[styleName];
        }
      });
      if (this.contents) {
        this.contents = newDelta;
      }
      this.delta = newDelta;
    }
  },

  applyContents: function(contents) {
    if (this.delta) {
      this.delta = new Delta(contents);
      this.initDimensions();
    }
  },

  toObject: function(propertiesToInclude) {
    if (Array.isArray(this.contents)) {
      if (this.contents[0].insert) {
        this.contents = new Delta({ ops: [...this.contents] });
      } else {
        this.contents = this.delta;
      }
    }

    return this.callSuper(
      'toObject',
      [
        'minWidth',
        'splitByGrapheme',
        'bulletStyleId',
        'customBulletStyle',
      ].concat(propertiesToInclude),
    );
  },
});

LudusText.fromObject = function fromObject(object, callback) {
  return fabric.Object._fromObject('LudusText', object, callback, 'text');
};

LudusText.deltaToText = delta => {
  const _text = delta.reduce(function(text, op) {
    if (!op) {
      return text;
    }
    if (!op?.insert)
      throw new TypeError('only `insert` operations can be transformed!');
    if (typeof op?.insert !== 'string') return text + ' ';
    return text + op?.insert || '';
  }, '');

  if (escape(_text.slice(-1)) === '%0A') {
    // the last char in a Quill is always a line break. Don't ask me why... but we get rid of it.
    return _text.slice(0, -1);
  }
  return _text;
};

LudusText.migrateTextToDelta = (text, options) => {
  const hasStyle = options.styles && !isEmpty(options.styles);
  const unwrappedTextLines = text.split(_reNewline);
  const ops = [];
  const styles = options.styles;

  unwrappedTextLines.forEach((line, mainIndex) => {
    if (mainIndex > 0) {
      ops.push({ insert: '\n' });
    }
    line.split('').forEach((char, index) => {
      const style = hasStyle && styles[mainIndex] && styles[mainIndex][index];
      const prevStyle =
        hasStyle && styles[mainIndex] && styles[mainIndex][index - 1];
      const op = ops[ops.length - 1];

      if (style === undefined && prevStyle !== undefined) {
        ops.push({ insert: char });
      } else if (style === undefined && prevStyle === undefined) {
        op ? (op.insert = op.insert + char) : ops.push({ insert: char });
      } else {
        style && style.originalChar && delete style.originalChar;
        prevStyle && prevStyle.originalChar && delete prevStyle.originalChar;
        if (index === 0) {
          ops.push({ insert: char, attributes: style });
        } else if (op && JSON.stringify(style) === JSON.stringify(prevStyle)) {
          op.insert = op.insert + char;
        } else {
          ops.push({ insert: char, attributes: style });
        }
      }
    });
  });
  return new Delta(ops);
};

export default LudusText;
